/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { user } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const USER_GET_OAUTH_INFO = 'user.oauth2.info';

queryClient.setQueryDefaults(USER_GET_OAUTH_INFO, {
  queryFn: () => user.oauthInfo(),
  onError: (error) => {
    handleError(error);
  },
});
